import React from "react";
import MeltingProcessMadeReliable from "./Hero";
import TransformingMeltingCards from "./TransformingMeltingCards";
import MapSection from "./MapSection";
import PlansPricing from "./PlansPricing";
import CustomerCards from "./CustomerCards";
import { Helmet } from "react-helmet-async";

function MetalcloudApplication() {
  return (
    <>
      <Helmet>
        <title>
          MetalCloud | Ensure Zero Defects - Supercharge Quality & Monitoring
          with AI
        </title>
        <meta
          name="description"
          content="Automate defect detection, melt planning, and casting quality control with MetalCloud's AI. Get real-time data & insights across visuals, chemistry, and execution."
        />
        <meta
          property="og:title"
          content="MetalCloud | Ensure Zero Defects - Supercharge Quality & Monitoring with AI"
        />
        <meta
          property="og:description"
          content="Automate defect detection, melt planning, and casting quality control with MetalCloud's AI. Get real-time data & insights across visuals, chemistry, and execution."
        />
        <meta
          property="twitter:title"
          content="MetalCloud | Ensure Zero Defects - Supercharge Quality & Monitoring with AI"
        />
        <meta
          property="twitter:description"
          content="Automate defect detection, melt planning, and casting quality control with MetalCloud's AI. Get real-time data & insights across visuals, chemistry, and execution."
        />
      </Helmet>
      <MeltingProcessMadeReliable />
      <TransformingMeltingCards />
      <MapSection />
      <CustomerCards />
    </>
  );
}

export default MetalcloudApplication;
